export default {
  page: "Contact"
};
